import React, { useEffect, useState, useRef } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Box, Checkbox, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import stylesForm from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import moment from 'moment';

import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { wsFindBy, wsGetAll, wsUpdate, wsGet } from 'services/WService';
import SweetAlertCustom from 'hooks/SweetAlertCustom';
// Permisos
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  ...stylesForm,
});

export default WithApp(function ESDModal(props) {
  const classes = useStyles();
  const model = props.model;
  const formApprobed = useRef(null);

  const [openAlert, setOpenAlert] = useState({ open: false });
  const [stateApprove, setStateApprove] = useState(false);

  const [vehicle, setVehicle] = useState({});
  const [programing, setPrograming] = useState({});
  const [initialData, setInitialData] = useState({});

  async function getPrograming(idProg) {
    let response = await wsGet('prog/sheet-distribution', idProg);
    if (response.success) {
      setPrograming(response.data);
      setInitialData(response.data);
      listVehicles(response.data.base_zone_id);
      setStateApprove(response.data.confirmed === 'Y' ? true : false);
      listManager(response.data.base_zone_id);
      setVehicle(response.data.vehicle);
    }
  }

  const handleChange = (e) => {
    setPrograming({
      ...programing,
      [e.target.name]: e.target.value,
    });
  };

  function selectVehicle(vehicle) {
    setVehicle(vehicle);
    let change = {
      prog_vehicle_id: vehicle.id,
      prog_distribution_staff_id_manager: vehicle.prog_distribution_staff_id_manager,
      prog_distribution_staff_id_inventory_manager:
        vehicle.prog_distribution_staff_id_inventory_manager,
    };
    setPrograming({ ...programing, ...change });
  }

  //#region Listados
  const [vehicles, setVehicles] = useState([]);
  const [managers, setManagers] = useState([]);
  const [bosses, setBosses] = useState([]);

  async function listVehicles(zone) {
    let response = await wsFindBy('prog/vehicle', 'base_zone_id', zone);
    if (response.success) setVehicles(response.data);
  }

  async function listManager(zone) {
    let response = await wsFindBy('prog/distribution-staff', 'base_zone_id', zone);
    if (response.success) {
      setManagers(response.data.filter((item) => item.base_employee_positon_id == '1'));
      setBosses(response.data.filter((item) => item.base_employee_positon_id == '2'));
    }
  }
  //#endregion

  async function approve() {
    let data = {};
    for (let input of formApprobed.current.querySelectorAll('[name]')) {
      data[input.name] = input.value;
    }

    let newData = {};
    for (let key of Object.keys(data)) {
      if (initialData[key] != data[key]) {
        newData[key] = data[key];
      }
    }

    let response = await wsUpdate('prog/sheet-distribution', programing.id, {
      ...newData,
      confirmed: openAlert.checked === true ? 'Y' : 'N',
    });
    if (response.success) {
      setStateApprove(openAlert.checked);
      props.reload();
      props.showNotify(response.message);
    } else {
      props.showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (model.open) {
      getPrograming(model.id);
    }
  }, [model.open]);

  return (
    <Modal
      title={'Programación - N° HR: ' + model.id}
      model={model}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      maxWidth="sm"
      fullWidth
      entity="prog/sheet-distribution"
      disabledSave={stateApprove}
    >
      <SweetAlertCustom
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        confirm={approve}
        rejected={() => { }}
      />
      {programing.id === undefined && (
        <Box display="flex" flexDirection="column" alignItems="center" mb={5}>
          <LoadingSpinner />
        </Box>
      )}
      {Object.keys(programing).length > 0 ? (
        <div ref={formApprobed}>
          <GridContainer>
            <GridItem sm={6} xs={12}>
              <TextField
                disabled
                label="Programado"
                type="date"
                fullWidth
                size="small"
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                value={moment(programing.scheduled_date).format('YYYY-MM-DD') || ''}
              />
            </GridItem>
            <GridItem sm={6} xs={12}>
              <TextField
                disabled={stateApprove}
                label="Despacho"
                type="date"
                fullWidth
                name="dispatch_date"
                size="small"
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ min: moment().format('YYYY-MM-DD') }}
                value={moment(programing.dispatch_date).format('YYYY-MM-DD') || ''}
                onChange={handleChange}
              />
            </GridItem>
            <GridItem sm={12} xs={12}>
              <FormControl fullWidth size="small" margin="normal">
                <InputLabel>Vehículos</InputLabel>
                <Select
                  disabled={stateApprove}
                  required
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  inputProps={{
                    name: 'prog_vehicle_id',
                  }}
                  value={programing.prog_vehicle_id || ''}
                >
                  {vehicles.map((vehicle) => {
                    return (
                      <MenuItem
                        value={vehicle.id}
                        onClick={() => {
                          selectVehicle(vehicle);
                        }}
                        key={vehicle.id}
                      >
                        {vehicle.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem sm={3} xs={12}>
              <TextField
                label="Cod. Vehiculo"
                fullWidth
                size="small"
                margin="normal"
                value={vehicle?.code || ''}
                disabled
              />
            </GridItem>
            <GridItem sm={3} xs={12}>
              <TextField
                label="Capcidad(Peso)"
                fullWidth
                size="small"
                margin="normal"
                value={vehicle?.weight || ''}
                disabled
              />
            </GridItem>
            <GridItem sm={3} xs={12}>
              <TextField
                label="Modelo"
                fullWidth
                size="small"
                margin="normal"
                value={vehicle?.model || ''}
                disabled
              />
            </GridItem>
            <GridItem sm={3} xs={12}>
              <TextField
                label="Color"
                fullWidth
                size="small"
                margin="normal"
                value={vehicle?.color || ''}
                disabled
              />
            </GridItem>
            <GridItem sm={12} xs={12}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Encargado de mercadería</InputLabel>
                <Select
                  required
                  disabled={stateApprove}
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  inputProps={{
                    name: 'prog_distribution_staff_id_inventory_manager',
                    onChange: handleChange,
                  }}
                  value={programing.prog_distribution_staff_id_inventory_manager || ''}
                >
                  {managers.map((bManagers, i) => {
                    return (
                      <MenuItem value={bManagers.id} key={i}>
                        {bManagers.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem sm={6} xs={12}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Jefe Reparto</InputLabel>
                <Select
                  required
                  disabled={stateApprove}
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  inputProps={{
                    name: 'prog_distribution_staff_id_manager',
                    onChange: handleChange,
                  }}
                  value={programing.prog_distribution_staff_id_manager || ''}
                >
                  {bosses.map((bBosses, i) => {
                    return (
                      <MenuItem value={bBosses.id} key={i}>
                        {bBosses.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem sm={6} xs={12}>
              <TextField
                label="lic. Conducir"
                fullWidth
                margin="normal"
                size="small"
                value={
                  bosses?.filter(
                    (item) => item.id == programing.prog_distribution_staff_id_manager,
                  )[0]?.driver_license || ''
                }
                disabled
              />
            </GridItem>
            <GridItem sm={12} xs={12}>
              <hr style={{ marginBottom: '2px' }} />
              <AllowedGuard
                permission={ConstantPermissions.PROG_SHEET_DISTRIBUTIONS_UNCONFIRM}
                component={
                  <>
                    <Checkbox
                      style={{ cursor: 'pointer' }}
                      checked={stateApprove}
                      onChange={(e) => {
                        let checked = e.target.checked;
                        setOpenAlert({
                          open: true,
                          type: 'confirm',
                          checked,
                          title: '¿Está seguro de Aprobar?',
                        });
                      }}
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                      disabled={stateApprove}
                    />
                    Confirmar
                  </>
                }
              >
                <>
                  <Checkbox
                    style={{ cursor: 'pointer' }}
                    checked={stateApprove}
                    onChange={(e) => {
                      let checked = e.target.checked;
                      let title = '¿Está seguro de Aprobar?';
                      if (checked === false) {
                        title = '¿Está seguro de Desconfirmar?';
                      }
                      setOpenAlert({
                        open: true,
                        type: 'confirm',
                        checked,
                        title,
                      });
                    }}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  Confirmar
                </>
              </AllowedGuard>
            </GridItem>
          </GridContainer>
        </div>
      ) : undefined}
    </Modal>
  );
});
